var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiobetterLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1E2C",
    d: "M0 0h5.236v40H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.037,
    cy: 25.131,
    r: 14.869,
    fill: "#1D1E2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiobetterLogoBlue);
export default __webpack_public_path__ + "static/media/biobetter-logo-blue.1789d786e9c00923fe4a6ad76a6d5d72.svg";
export { ForwardRef as ReactComponent };